import { render, staticRenderFns } from "./SentimentForm.vue?vue&type=template&id=689a61c7&"
import script from "./SentimentForm.vue?vue&type=script&lang=ts&"
export * from "./SentimentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports